<template>
    <div class="py-4 container-fluid"> 
        <div class="row">
            <div class="mx-auto col-lg-12 col-12">
                <div class="mt-4 card card-body">
                    <div id="print" class="px-1">
                        <h2 class="fs-3 fw-bold text-center">
                            PT. SMARTIN ADVISOR SISTEM
                        </h2>
                        <h2 class="fs-3 fw-bold mb-5 text-center">
                            PERJANJIAN PEMBERIAN JASA
                        </h2>
                        <p>
                            Pada hari ini {{ formattedLetterDate() }} saya yang mengisi perjanjian
                            dibawah ini :
                        </p>
                        <table class="not-table">
                        <tbody>
                                <tr>
                                    <td class="p-1 width-8p">Nama</td>
                                    <td class="p-1 width-1">:</td>
                                    <td class="p-1">{{ record?.full_name ?? "-" }}</td>
                                </tr>
                                <tr>
                                    <td class="p-1 width-8p">NIK KTP</td>
                                    <td class="p-1 width-1">:</td>
                                    <td class="p-1">{{ user?.id_card_number ?? "-" }}</td>
                                </tr>
                                <tr>
                                    <td class="p-1 width-8p">Alamat</td>
                                    <td class="p-1 width-1">:</td>
                                    <td class="p-1">{{ `${user?.residential_address}, ${user?.city}, ${user?.province}, ${user?.country}, ${user?.postal_code}` }}</td>
                                </tr>
                                <tr>
                                    <td class="p-1 width-8p">No Telp</td>
                                    <td class="p-1 width-1">:</td>
                                    <td class="p-1">{{ user?.phone ?? "-" }}</td>
                                </tr>
                        </tbody>
                        </table>
                        <p>
                            dalam hal ini bertindak atas nama sendiri yang selanjutnya disebut Klien,
                        </p>
                        <p>&nbsp;</p>
                        <table class="not-table">
                            <tbody>
                                <tr>
                                    <td class="p-1 width-8p">Nama</td>
                                    <td class="p-1 width-1">:</td>
                                    <td class="p-1">Dr. Odang Supriatna</td>
                                </tr>
                                <tr>
                                    <td class="p-1 width-8p">Jabatan</td>
                                    <td class="p-1 width-1">:</td>
                                    <td class="p-1">Direktur Utama</td>
                                </tr>
                                <tr>
                                    <td class="p-1 width-8p">Alamat</td>
                                    <td class="p-1 width-1">:</td>
                                    <td class="p-1">ITS Tower Nifarro Park Lt. 29, No.18,
                                        Jl. Raya Pasar Minggu, Pejaten Timur, Jakarta Selatan</td>
                                </tr>
                                <tr>
                                    <td class="p-1 width-8p">No Telp</td>
                                    <td class="p-1 width-1">:</td>
                                    <td class="p-1">0811-190-454</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>&nbsp;</p>
                        <p>
                            Dalam hal ini bertindak untuk dan atas nama PT. Smartin Advisor Sistem, yang
                            selanjutnya disebut Penasihat Berjangka,
                        </p>
                        <p>&nbsp;</p>
                        <p>
                            Para Pihak sepakat untuk membuat perjanjian Pemberian Jasa Nasihat Berjangka
                            dari Penasihat Berjangka kepada Klien dan menyetujui bahwa Penasihat Berjangka
                            tidak dapat dimintakan pertanggungjawaban atas semua risiko dan kerugian yang
                            terjadi akibat Perdagangan Berjangka Komoditi.
                        </p>
                        <p>&nbsp;</p>
                        <p>
                            Perjanjian Pemberian Jasa Penasihat Berjangka Berdasarkan Teknologi Informasi
                            Berupa Expert Advisor akan dijelaskan secara rinci sebagai berikut:
                        </p>
                        <p>&nbsp;</p>
                        <ol class="first-list">
                            <li class="decimal-list">
                                <strong>Pemberian Imbalan Layanan Jasa Nasihat </strong>
                            <p class="text-indent">
                                    Sebagai imbalan atas Jasa Nasihat yang diberikan Penasihat Berjangka, Klien
                                    wajib menyerahkan atau menyetorkan uang ke rekening perusahaan Penasihat
                                    Berjangka pada saat di terima menjadi klien dan sudah menandatangani
                                    Dokumen Perjanjian Pemberian Jasa. Biaya jasa layanan berlaku untuk jangka
                                    waktu 30 hari. Besaran Biaya yang ditetapkan oleh penasihat berjangka kepada
                                    klien yaitu ;
                            </p>
                            <p>&nbsp;</p>
                            <ol class="first-list">
                                    <li class="decimal-list">
                                        <span>SAS Signal – Indikator (Rp 600.000/bln)</span>
                                        <p class="text-indent">
                                            Klien mendapatkan akses satu Dashboard Market Forex dan Gold.
                                            Terdapat penambahan biaya untuk notifikasi di ponsel klien atas Signal
                                            – Indikator. Tarif yang dikenakan sebesar Rp 100.000. Hal ini dijalankan
                                            berdasarkan pemintaan Klien.
                                        </p>
                                    </li>
                                    <li class="decimal-list">
                                        <span>SAS Edukasi</span>
                                        <ol class="third-item">
                                            <li class="low-alpha-list">
                                                <p>Basic (Rp 500.000/Pelatihan)</p>
                                                <p>Klien mendapatkan pelatihan PBK mengenai Forex.</p>
                                            </li>
                                            <li class="low-alpha-list">
                                                <p>Intermediate (Rp 1.500.000/Pelatihan)</p>
                                                <p>Klien mendapatkan pelatihan PBK mengenai Forex dan Gold.</p>
                                            </li>
                                            <li class="low-alpha-list">
                                                <p>Advanced (Rp 3.000.000/Pelatihan)</p>
                                                <p>
                                                    Klien mendapatkan pelatihan PBK mengenai Forex, Gold, Oil dan
                                                    komoditi lainnya.
                                                </p>
                                            </li>
                                            <li class="low-alpha-list">
                                                <p>SAS Smartbot (Perbulan)</p>
                                                <p>&nbsp;</p>
                                                <p class="title-bg fix-margin">BIAYA JASA LAYANAN MENGGUNAKAN EA (SAS SMARTBOT)</p>
                                                <p>&nbsp;</p>
                                                <div class="fix-margin">
                                                    <div class="d-flex flex-column flex-md-row justify-content-between">
                                                        <v-table class="styled-table">
                                                            <thead style="background-color: #FBE3D5;">
                                                                <tr>
                                                                    <th colspan="2" class="text-center text-uppercase"><strong>METODE KONSERVATIF</strong></th>
                                                                </tr>
                                                                <tr>
                                                                    <th class="text-center">Margin in</th>
                                                                    <th class="text-center">Jasa Layanan BOT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td class="text-center">$ 5,000</td>
                                                                    <td class="text-center">Rp 1,500,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 6,000</td>
                                                                    <td class="text-center">Rp 1,800,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 7,000</td>
                                                                    <td class="text-center">Rp 2,100,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 8,000</td>
                                                                    <td class="text-center">Rp 2,400,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 9,000</td>
                                                                    <td class="text-center">Rp 2,700,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 10,000</td>
                                                                    <td class="text-center">Rp 3,000,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">Dst...</td>
                                                                    <td class="text-center">Dst...</td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                        <v-table class="styled-table">
                                                            <thead style="background-color: #FBE3D5;">
                                                                <tr>
                                                                    <th colspan="2" class="text-center text-uppercase"><strong>METODE MODERATE</strong></th>
                                                                </tr>
                                                                <tr>
                                                                    <th class="text-center">Margin in</th>
                                                                    <th class="text-center">Jasa Layanan BOT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td class="text-center">$ 5,000</td>
                                                                    <td class="text-center">Rp 2,250,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 6,000</td>
                                                                    <td class="text-center">Rp 2,700,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 7,000</td>
                                                                    <td class="text-center">Rp 3,150,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 8,000</td>
                                                                    <td class="text-center">Rp 3,600,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 9,000</td>
                                                                    <td class="text-center">Rp 4,050,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 10,000</td>
                                                                    <td class="text-center">Rp 4,500,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">Dst...</td>
                                                                    <td class="text-center">Dst...</td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                        <v-table class="styled-table">
                                                            <thead style="background-color: #FBE3D5;">
                                                                <tr>
                                                                    <th colspan="2" class="text-center text-uppercase"><strong>METODE AGRESSIVE</strong></th>
                                                                </tr>
                                                                <tr>
                                                                    <th class="text-center">Margin in</th>
                                                                    <th class="text-center">Jasa Layanan BOT</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td class="text-center">$ 5,000</td>
                                                                    <td class="text-center">Rp 3,000,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 6,000</td>
                                                                    <td class="text-center">Rp 3,600,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 7,000</td>
                                                                    <td class="text-center">Rp 4,200,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 8,000</td>
                                                                    <td class="text-center">Rp 4,800,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 9,000</td>
                                                                    <td class="text-center">Rp 5,400,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">$ 10,000</td>
                                                                    <td class="text-center">Rp 6,000,000</td>
                                                                </tr>
                                                                <tr>
                                                                    <td class="text-center">Dst...</td>
                                                                    <td class="text-center">Dst...</td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </div>
                                                </div>
                                                <p>&nbsp;</p>
                                                <p class="text-notes">*Rate sesuai ketentuan yang berlaku.</p>
                                            </li>
                                        </ol>
                                    </li>
                            </ol>
                            </li>
                            <p>&nbsp;</p>
                            <li class="decimal-list">
                                <strong>Syarat dan Ketentuan Layanan Jasa Nasihat </strong>
                                <ol class="first-list">
                                    <li class="low-alpha-list">
                                        Sebelum mendapatkan jasa nasihat,klien wajib menyetorkan terlebih dahulu
                                        fee di awal ke Bank BCA dalam rupiah atas nama PT. Smartin Advisor Sistem
                                        dengan Nomor Rekening 035 324 1505
                                    </li>
                                    <li class="low-alpha-list">
                                        Biaya Jasa yang sudah disetorkan oleh Klien ke rekening perusahaan
                                        Penasihat Berjangka tidak dapat ditagih atau ditarik kembali. 
                                    </li>
                                    <li class="low-alpha-list">
                                        Biaya yang dikeluarkan oleh klien wajib dibayarkan pada setiap awal
                                        periode pemilihan Layanan Jasa Nasihat. PT. Smartin Advisor Sistem tidak
                                        akan membebankan biaya dalam bentuk apapun terkait dengan keuntungan
                                        atau kerugian yang diterima oleh Klien. 
                                    </li>
                                    <li class="low-alpha-list">
                                        Segala bentuk risiko, kegagalan dan intervensi yang dilakukan oleh klien
                                        dalam investasi yang berakibat pada kerugian sepenuhnya bukan
                                        tanggungjawab perusahaan melainkan menjadi tanggungjawab klien yang
                                        bersangkutan. PT. Smartin Advisor Sistem secara penuh merupakan
                                        Penasihat Berjangka yang hanya memberikan saran dan rekomendasi atas
                                        investasi yang dilakukan oleh klien.
                                    </li>
                                    <li class="low-alpha-list">
                                        Apabila terjadi pemberhentian EA yang disebabkan oleh pedagang maka
                                        klien dapat menyampaikan keberatannya kepada Pialang Berjangka dan PT.
                                        Smartin Advisor Sistem akan mempertimbangkan untuk menambah batas
                                        waktu Layanan Jasa Nasihat.
                                    </li>
                                    <li class="low-alpha-list">
                                        Jika koneksi dari VPS (Virtual Private Server) terputus maka Akun dan EA
                                        akan berhenti. Sehingga mengakibatkan tidak adanya transaksi yang
                                        dijalankan. Untuk hal ini, Klien dapat menghubungi admin PT. Smartin
                                        Advisor Sistem agar dapat dilakukan pengaktifan kembali akun dan EA
                                        didalam VPS
                                    </li>
                                </ol>
                            </li>
                            <p>&nbsp;</p>
                            <li class="decimal-list" start="10">
                                <strong>Larangan Bagi Penasihat Berjangka</strong>
                                <ol class="first-list">
                                    <li class="low-alpha-list">
                                        Penasihat Berjangka tidak akan menerima dana atau surat berharga dari
                                        Klien sebagai Margin/uang muka untuk melakukan transasksi kontrak
                                        Berjangka atau Perdagangan Pasar Fisik di Bursa Berjangka Berjangka. 
                                    </li>
                                    <li class="low-alpha-list">
                                        Penasihat Berjangka dilarang untuk memberikan nasihat transaksi yang
                                        mengarah pada produk atau pelaku usaha yang illegal di bidang
                                        Perdagangan Berjangka Komoditi. 
                                    </li>
                                </ol>
                            </li>
                            <p>&nbsp;</p>
                            <li class="decimal-list" start="10">
                                <strong>Pemberian Nasihat</strong>
                                <p class="text-indent">
                                    Penasihat berjangka akan memberikan rekomendasi dan informasi
                                    kepada Klien melalui Paket Layanan Jasa Nasihat yang telah disediakan oleh
                                    SAS. Apabila Layanan yang digunakan mengalami kendala sehingga
                                    rekomendasi dan informasi tidak dapat disampaikan, maka Penasihat
                                    Berjangka akan menyampaikan melalui Email dan nomor Whatsapp yang
                                    tertera di website www.smartintrade.com. 
                                </p>
                                <p>&nbsp;</p>
                                <p class="text-indent">
                                    Rekomendasi yang diberikan oleh Penasihat Berjangka kepada Klien
                                    disampaikan secara langsung paling tidak mengenai harga dan volume
                                    perdagangan komoditi, risiko harga, likuiditas, faktor-faktor yang
                                    mempengaruhi pergerakan harga, mekanisme perdagangan berjangka,
                                    seluruh institusi atau Lembaga yang terlibat dalam Perdagangan Berjangka
                                    dan hal-hal lain yang dipandang perlu. 
                                </p>
                                <p>&nbsp;</p>
                                <p class="text-indent">
                                    Sedangkan informasi yang diberikan oleh Penasihat Berjangka adalah
                                    informasi tambahan yang dipandang perlu untuk disampaikan yang
                                    bermanfaat bagi Klien dalam mengambil keputusan terkait transaksi yang
                                    akan dilakukan. 
                                </p>
                                <p>&nbsp;</p>
                                <p class="text-indent">
                                    Penasihat Berjangka yang dalam hal kegiatannya berhubungan dengan
                                    Klien diwakili oleh Wakil Penasihat Berjangka memberikan Jasa Nasihat
                                    untuk :
                                </p>
                                <p>&nbsp;</p>
                                <ol class="first-list">
                                    <li class="low-alpha-list">
                                        Transaksi Kontrak Berjangka emas yang diperdagangkan di Bursa
                                        Berjangka. 
                                    </li>
                                    <li class="low-alpha-list">
                                        Transaksi Kontrak Derivatif, Forex yang diperdagangkan pada Sistem
                                        Perdagangan Alternatif (SPA).  
                                    </li>
                                    <li class="low-alpha-list">
                                        Jasa Berbasis Teknologi Informasi Berupa Expert Advisor.
                                    </li>
                                </ol>
                                <p>&nbsp;</p>
                                <p class="text-indent">
                                    Jenis transaksi diatas merupakan bentuk perdagangan yang telah
                                    ditetapkan dan diatur oleh Bappebti. Klien yang telah mendapat Jasa Nasihat
                                    dari Penasihat Berjangka yang akan memutuskan dan mengeksekusi
                                    transaksi baik melalui Pialang Berjangka yang telah memiliki legalitas dari
                                    Bappebti. Penasihat Berjangka tidak akan memberikan Jasa Nasihat kepada
                                    Klien untuk bertransaksi dan/atau menempatkan dananya di Pialang
                                    Berjangka yang belum memiliki legalitas dari BAPPEBTI.
                                </p>
                            </li>
                            <p>&nbsp;</p>
                            <li class="decimal-list">
                                <strong>Penyampaian Nasihat Kepada klien</strong>
                                <p>&nbsp;</p>
                                <p class="text-indent">
                                    Penasihat Berjangka dalam menyampaikan rekomendasi dan informasi
                                    kepada Klien terkait pelaksanaan transaksi Perdagangan Berjangka Komoditi
                                    hanya melalui Wakil Penasihat Berjangka. Penasihat Berjangka akan
                                    menetapkan Wakil Penasihat Berjangka yang akan berhubungan secara
                                    langsung secara terus menerus dengan Klien sesuai dengan jangka waktu
                                    perjanjian yang telah disepakati. Apabila ada pihak lain yang menghubungi
                                    Klien dengan mengatas namakan Penasihat Berjangka atau Wakil Penasihat,
                                    maka Klien berhak menolak dan melaporkan hal tersebut kepada Penasihat
                                    Berjangka.
                                </p>
                            </li>
                            <p>&nbsp;</p>
                            <li class="decimal-list">
                                <strong>Klien Melakukan Transaksi Sendiri </strong>
                                <p>&nbsp;</p>
                                <p class="text-indent">
                                    Setiap rekomendasi dan informasi yang diterima oleh Klien dari
                                    Penasihat Berjangka, maka keputusan untuk melakukan transaksi atau tidak
                                    ada pada Klien. Segala akibat dari transaksi yang dilakukan oleh Klien menjadi
                                    tanggung jawab sendiri dan tidak menjadi tanggung jawab Penasihat
                                    Berjangka.
                                </p>
                            </li>
                            <p>&nbsp;</p>
                            <li class="decimal-list">
                                <strong>Larangan Menerima Kuasa</strong>
                                <p>&nbsp;</p>
                                <ol class="first-list">
                                    <li class="low-alpha-list">
                                        Penasihat Berjangka dan Wakil Penasihat Berjangka dilarang menerima
                                        kuasa dari Klien untuk melakukan atau mengeksekusi transaksi,
                                        mengelola dana dan kegiatan lainnya yang telah diatur dalam Peraturan
                                        Perdagangan Berjangka Komoditi. Penasihat Berjangka hanya dapat
                                        menerima kuasa dalam hal tertentu sesuai dengan ketentuan yang
                                        ditetapkan Kepala Bappebti.
                                    </li>
                                    <li class="low-alpha-list">
                                        Keadaan tertentu hanya untuk transaksi Kontrak Berjangka dan/atau
                                        dalam rangka memfasilitasi Sentra Dana Berjangka dan terbatas hanya
                                        dapat digunakan untuk Klien yang memiliki penghasilan kotor paling
                                        sedikit Rp1.000.000.000,- (satu miliar rupiah) per tahun;
                                        Bentuk pemberian kuasa dari Klien kepada Penasihat Berjangka
                                        dilakukan dengan berpedoman pada Formulir Nomor I.PSB.13 yang
                                        tercantum dalam Lampiran Peraturan Bappebti Nomor 6 Tahun 2020;
                                    </li>
                                    <li class="low-alpha-list">
                                        Pemberian kuasa wajib dilakukan atas keinginan sendiri dari Klien dan
                                        Penasihat Berjangka dilarang untuk menawarkan, mempengaruhi atau
                                        meminta kepada Klien untuk memberikan kuasanya kepada Penasihat
                                        Berjangka. 
                                    </li>
                                </ol>
                            </li>
                            <p>&nbsp;</p>
                            <li class="decimal-list">
                                <strong>Merahasiakan Data dan Informasi Klien</strong>
                                <p class="text-indent">
                                    Penasihat Berjangka wajib menyimpan dan menjaga kerahasiaan semua
                                    data yang dimiliki mengenai Klien. Demikian juga setiap informasi yang
                                    diberikan atau yang diterima dari Klien wajib disimpan dan dijaga
                                    kerahasiaannya oleh Penasihat Berjangka. Kerahasiaan data dan informasi
                                    Klien hanya dapat diberikan kepada pihak lain atas persetujuan Klien atau
                                    dalam rangka pelaporan kepada Bappebti. 
                                </p>
                            </li>
                            <p>&nbsp;</p>
                            <li class="decimal-list">
                                <strong>Batas Waktu Perjanjian Pemberian Jasa</strong>
                                <p>
                                    Batas waktu perjanjian pemberian jasa Nasihat mulai berlaku
                                    {{ validFor() }}.
                                    Demikianlah Perjanjian Pemberian Jasa Nasihat dibuat dan di tanda tangani
                                    oleh Klien dan Penasihat Berjangka tanpa adanya paksaan dan tekanan dari
                                    pihak manapun. 
                                </p>
                            </li>
                        </ol>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>Jakarta, {{ formattedSignDate() }}</p>
                        <div class="d-flex justify-content-between">
                            <div>
                                <p>Klien</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p>({{ user?.fullname ?? '……………………………………………'}})</p>
                            </div>
                            <div>
                                <p>Penasihat Berjangka</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p>(……………………………………………)</p>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-primary mt-5 w-40 mx-auto" @click="generatePDF">Download PDF</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import SubscriptionService from "@/services/subscriptions.service.js";
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const toastId = ref('');
const moment = require('moment');
moment.locale('id');

export default {
    name: "ServiceProvider",
    data() {
        return {
            record: {},
            user: {},
        };
    },
    mounted() {
        this.getRecord()
    },
    methods: {
        showLoading(){
            toastId.value = toast.loading('Please wait...');
        },
        hideLoading(){
            setTimeout(() => {
                toast.remove(toastId.value)
            }, 1000); 
        },
        getRecord(){
            this.showLoading()
            SubscriptionService.get(this.$route.params.id).then(e => {
                this.record = e.data.subscribe_data
                this.user = e.data.user_data
                this.hideLoading()
            }).catch(e => {
                this.showFailed(e.response.data.code_message)           
            });
        },
        formattedLetterDate() {
            const date = this.record.transaction_date ? this.record.transaction_date : this.record.updated_at
            return moment(date).format("dddd, [tanggal] DD [bulan] MMMM [tahun] YYYY");
        },
        formattedSignDate() {
            const date = this.record.transaction_date ? this.record.transaction_date : this.record.updated_at
            return moment(date).format("DD MMMM YYYY");
        },
        validFor() {
            const startDate = moment(this.record.active_from).format("DD MMMM YYYY")
            const endDate = this.record.active_from && this.record.active_until && this.record.active_until !== this.record.active_from? moment(this.record.active_until).format("DD MMMM YYYY") : '-'

            return `pada ${startDate} sampai dengan ${endDate}`
        },
        async generatePDF() {
            if (typeof window !== 'undefined') {
                const html2pdf = await import('html2pdf.js');
                const element = document.getElementById('print');
                if (!element) {
                    console.error('Element with id "print" not found');
                    return;
                }

                html2pdf.default()
                    .from(element)
                    .set({
                        margin: 1, // Top, Right, Bottom, Left margins
                        filename: `service-provider-agreement.pdf`,
                        image: { type: 'jpeg', quality: 0.98 },
                        html2canvas: { scale: 2 },
                        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
                    })
                    .save();
            } else {
                console.error('Function executed outside the browser environment');
            }
        },

    }
};
</script>

<style scoped>
.width-8p {
    width: 8%;
}
.width-1 {
    width: 1%;
}
.not-table {
    margin-left: -3.5px; 
    border: none; 
    border-collapse: 
    collapse; width: 100%;
}
.first-list {
    margin-left: 16px
}
.third-item {
    margin-left: 20px;
}
.decimal-list {
    list-style: decimal;
    padding-left: 10px;
}
.low-alpha-list {
    list-style: lower-alpha;
    padding-left: 10px;
}
.text-indent {
    text-indent: 25px;
}
.title-bg {
    background-color: #EC7D31;
    font-weight: bolder;
    text-align: center;
}
.fix-margin {
    margin-left: -82px;
}
.text-notes {
    font-size: 12px;
}

/* Table */
.styled-table {
  border-collapse: collapse;
}

.styled-table th,
.styled-table td {
  /* border: 1px solid #000; */
  padding: 8px;
  font-size: 14px;
}

.styled-table th {
  background-color: #FBE3D5;
  font-weight: bold;
  text-align: center;
}

.styled-table td {
  text-align: center;
  vertical-align: middle;
}
</style>